import {
  ArrowElbowDownRight,
  ArrowsSplit,
  BookOpen,
  BracketsCurly,
  CalendarBlank,
  CalendarDots,
  ChatCircle,
  ChatText,
  EnvelopeSimple,
  FilmStrip,
  Handshake,
  Hash,
  Hourglass,
  type Icon,
  ImageSquare,
  Lightbulb,
  LinkSimple,
  ListChecks,
  Package,
  Phone,
  Question,
  Sparkle,
  Star,
  StopCircle,
  Textbox,
  User,
  VideoCamera,
  WebhooksLogo,
} from '@/core/ui/icons';
import type { BlockCategory, BlockIcon } from '../domain/blocks';
import type { ShortcutIcon } from '../domain/types';

export const BLOCK_ICONS: Record<BlockIcon, Icon> = {
  text: ChatText,
  image: ImageSquare,
  video: FilmStrip,
  link: LinkSimple,
  choice: ListChecks,
  input_text: Textbox,
  email: EnvelopeSimple,
  phone: Phone,
  number: Hash,
  date: CalendarBlank,
  rating: Star,
  condition: ArrowsSplit,
  set_variable: BracketsCurly,
  jump: ArrowElbowDownRight,
  wait: Hourglass,
  end: StopCircle,
  ai: Sparkle,
  visit: Handshake,
  webhook: WebhooksLogo,
  open: BookOpen,
};

/** Tom de cada família de blocos — o ícone no card e na paleta. */
export const CATEGORY_TONE: Record<BlockCategory, string> = {
  messages: 'bg-sky-50 text-sky-700',
  inputs: 'bg-amber-50 text-amber-700',
  logic: 'bg-violet-50 text-violet-700',
  actions: 'bg-teal-50 text-teal-700',
};

export const SHORTCUT_ICON_COMPONENTS: Record<ShortcutIcon, Icon> = {
  sparkle: Sparkle,
  chat: ChatCircle,
  question: Question,
  book: BookOpen,
  video: VideoCamera,
  calendar: CalendarDots,
  handshake: Handshake,
  phone: Phone,
  lightbulb: Lightbulb,
  package: Package,
  star: Star,
  user: User,
};
